import React from 'react';

import { Helmet } from 'react-helmet';

import { Link, makeStyles } from '@material-ui/core';

import { Icon, NotificationBanner } from '@hydra/common/components';
import Translate from '@hydra/common/components/i18n/Translate';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(6, 'auto'),
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  text: {
    margin: theme.spacing(3, 0)
  }
}));

export default function ReactivateSubscriptionPage () {
  const classes = useStyles();
  const { locale, translate } = useI18n();

  return (
    <>
      <Helmet>
        <title>{translate('hydra_subscription_reactivated_title')}</title>
      </Helmet>
      <div className={classes.root}>
        <div style={{ width: '100%' }}>
          <NotificationBanner severity='success' title={translate('hydra_subscription_reactivated')} icon={<Icon type='conversation' />} />
        </div>
        <Translate content='hydra_reactivation_confirmation_text' component='p' className={classes.text} />

        <Link href={`/${locale}/account`} color='primary'>
          <Translate content='my_account_page' />
        </Link>
      </div>
    </>
  );
}
